import React, { useEffect, useRef, useState } from "react";
import { CiLogout } from "react-icons/ci";
import ProfilePhoto from "../../Assets/images/icons/user.png";
const Profile = () => {
  const [open, setOpen] = useState(false);
  const userData = JSON.parse(localStorage.getItem("user"));
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("roles");
    localStorage.removeItem("permissions");
    window.location.href = "/Login"
  };

  return (
    <div className="relative  group" ref={dropdownRef}>
      {/* Profile Image */}
      <div
        className="flex gap-2 items-center justify-center cursor-pointer"
        onClick={() => setOpen(!open)}
      >
        <img
          className="w-12 h-12 rounded-full border-2 border-gray-300  transition-all duration-300"
          src={userData?.photo_url || ProfilePhoto}
          alt="Profile"
        />
        <div className="data px-2 flex flex-col items-start">
          <div className="name font-semibold">{userData?.name}</div>
          <div className="role text-gray-800 dark:text-darkTextColor">{userData?.role}</div>
        </div>
      </div>

      {/* Dropdown Menu */}
      <ul
        className={`absolute text-gray-700 bg-gray-100 dark:text-gray-50 dark:bg-gray-900 shadow-lg rounded-lg text-lg font-medium text-gray-600 -right-1 mt-2 w-32 
           transform transition-all duration-300 ease-in-out ${
             open
               ? "scale-100 opacity-100"
               : "scale-75 opacity-0 pointer-events-none"
           }`}
      >
        <li
          className="flex items-center px-4 py-2 text-sm cursor-pointer  hover:text-red-500   justify-center  transition-all duration-300 rounded-lg"
          onClick={handleLogout}
        >
          <CiLogout className="mr-2 text-lg" />
          Logout
        </li>
      </ul>
    </div>
  );
};

export default Profile;
